import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule, NgForOf, NgIf} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FuseAlertComponent} from '../../../../../../@fuse/components/alert';
import {DestinationType, PropertiesType} from '../../destinations.types';
import {MatCardModule} from "@angular/material/card";
import {MatRadioChange, MatRadioModule} from "@angular/material/radio";
import {MatCheckboxModule} from "@angular/material/checkbox";

@Component({
    selector: 'app-features-tab',
    templateUrl: './features-tab.component.html',
    styleUrls: ['./features-tab.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        NgIf,
        NgForOf,
        MatIconModule,
        MatTooltipModule,
        FuseAlertComponent,
        MatCardModule,
        MatRadioModule,
        MatCheckboxModule,
    ],
})
export class FeaturesTabComponent {
    @Input() destination: DestinationType;
    @Input() reviewMode: boolean = false;
    @Output() save = new EventEmitter<void>();

    isSingleSelect(item: PropertiesType): boolean {
        return item.vi_max_destinationpropdtype === 1 && item.vi_min_destinationpropdtype === 1;
    }

    countSelectedProps(properties: PropertiesType): number {
        return properties.ar_items.filter(prop => prop.bl_Active === true).length;
    }

    alertToggle(item: PropertiesType): boolean {
        const selectedCount = this.countSelectedProps(item);
        return selectedCount < item.vi_min_destinationpropdtype || selectedCount > item.vi_max_destinationpropdtype;
    }

    featuresAutosave(prop: any): void {
        prop.bl_Active = !prop.bl_Active;
        this.save.emit();
    }

    onRadioGroupChange(event: MatRadioChange, propArray: any[]): void {
        this.featuresAutosaveUnique(propArray, event.value);
    }

    featuresAutosaveUnique(propArray: any[], selectedProp: any): void {
        propArray.forEach(prop => {
            prop.bl_Active = (prop === selectedProp);
        });
        this.save.emit();
    }
}
